<template>
  <div class="shop-store-container">
    <!-- 顶部操作栏（已按之前要求优化） -->
    <div class="top-bar">
      <!-- 左侧：切换库房（带边框）+ 操作按钮 -->
      <div class="top-bar-left">
        <div class="warehouse-switch-box">
          <span class="switch-label">切换库房</span>
          <el-select
            v-model="currentWarehouseId"
            size="small"
            class="warehouse-select"
            @change="handleWarehouseChange"
          >
            <el-option
              v-for="item in warehouseOptions"
              :key="item.id"
              :label="item.label"
              :value="item.id"
            >
              <span :style="{ color: item.id === 1 ? '#409EFF' : '' }">
                {{ item.label }}
              </span>
            </el-option>
          </el-select>
        </div>

        <div class="divider">|</div>

        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          class="btn-create"
          @click="handleCreateInbound"
        >
          新建
        </el-button>

        <el-dropdown
          trigger="click"
          size="small"
          class="import-export-dropdown"
          @command="handleImportExport"
        >
          <el-button size="small" class="btn-import-export">
            <i class="el-icon-download"></i> 导入/导出
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown" class="import-export-menu">
            <el-dropdown-item command="batchImport">批量入库</el-dropdown-item>
            <el-dropdown-item command="exportInfo">导出入库信息</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>

      <!-- 右侧：筛选区域 -->
      <div class="top-bar-right">
        <div class="filter-box">
          <el-select
            v-model="filterForm.state"
            size="small"
            placeholder="入库状态"
            clearable
            class="filter-state"
          >
            <el-option label="草稿" :value="0" />
            <el-option label="已提交" :value="2" />
            <el-option label="已审核" :value="4" />
            <el-option label="已过单" :value="5" />
            <el-option label="已冲销" :value="6" />
          </el-select>
          <span class="divider-line"></span>
          <el-input
            v-model="filterForm.docNum"
            size="small"
            placeholder="查询入库单号"
            clearable
            class="filter-search"
            suffix-icon="el-icon-Ssearch"
            @keyup.enter.native="handleSearch"
          />
        </div>
        <!-- 日期按钮（Popover触发） -->
        <el-popover
          placement="bottom"
          width="auto"
          trigger="click"
          v-model="datePopoverVisible"
        >
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            size="small"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            :picker-options="pickerOptions"
            @change="handleDateConfirm"
          />
          <span slot="reference" class="date-trigger">
            <i class="el-icon-date"></i> 日期
          </span>
        </el-popover>
      </div>
    </div>

    <!-- 表格标题 -->
    <div class="table-header">
      <span class="table-title">{{ currentWarehouse.label }}采购列表清单</span>
      <span class="table-total">
        入库总成本合计：<span class="total-amount">{{ formattedTotalCost }}</span>
      </span>
    </div>

    <!-- 表格容器 -->
    <div class="table-container">
      <transition name="fade-slide" mode="out-in">
        <component
          ref="childComponent"
          :is="currentComponent"
          :key="currentWarehouse.id"
          :filterData="filterForm"
		  :mode="dialogMode"
          @switch-warehouse="handleSwitchWarehouseFromChild"
          @update-total-cost="handleUpdateTotalCost"
        />
      </transition>
    </div>

    <!-- 欢迎模态框（保留） -->
    <el-dialog
      title="系统提示"
      :visible.sync="welcomeDialogVisible"
      width="400px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :before-close="handleCloseWelcome"
      custom-class="welcome-dialog"
    >
      <div class="welcome-content">
        <div class="welcome-icon">
          <i class="el-icon-success"></i>
        </div>
        <div class="welcome-text">
          <h4>欢迎使用药品采购入库系统</h4>
          <p>当前默认操作库为：<strong>{{ currentWarehouse.label }}</strong></p>
          <p>此提示将在 <span class="countdown">{{ countdown }}</span> 秒后自动关闭</p>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="handleCloseWelcome">
          我已知晓 ({{ countdown }}s)
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import YK from './newInStore/yk/yk.vue'
import YF from './newInStore/yf/yf.vue'

export default {
  name: 'ShopStore',
  components: { YK, YF },
  data() {
    return {
      warehouseOptions: [
        { id: 1, label: '药库', value: 'yk' },
        { id: 2, label: '药房', value: 'yf' },
      ],
      currentWarehouseId: 1,
      currentWarehouse: { id: 1, label: '药库', value: 'yk' },
      filterForm: {
        state: '',
        putinTypeId: '',
        docNum: '',
        supplierName: '',
        drugName: '',
        startDate: '',
        endDate: '',
      },
	  dialogMode: 'add', // 新增：控制子组件模式
      dateRange: [],
      dateButtonText: '日期',
      datePopoverVisible: false,
      pickerOptions: {
        shortcuts: [
          {
            text: '三个月前',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setMonth(start.getMonth() - 3)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '三个月后',
            onClick(picker) {
              const start = new Date()
              const end = new Date()
              end.setMonth(end.getMonth() + 3)
              picker.$emit('pick', [start, end])
            },
          },
        ],
      },
      expanded: false,
      currentComponent: 'YK',
      totalCost: 0,
      welcomeDialogVisible: false,
      countdown: 3,
      countdownTimer: null,
      isInitialLoad: true,
      dropdownPosition: { x: 0, y: 0, width: 0, height: 0 },
    }
  },
  computed: {
    computedComponent() {
      const map = { 1: 'YK', 2: 'YF' }
      return map[this.currentWarehouse.id] || 'YK'
    },
    formattedTotalCost() {
      if (this.totalCost === 0) return '¥0.00'
      return '¥' + Number(this.totalCost).toLocaleString('zh-CN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    },
  },
  watch: {
    currentWarehouse: {
      handler(newVal) {
        this.currentComponent = this.computedComponent
      },
      immediate: true,
    },
  },
  mounted() {
    if (this.isInitialLoad) {
      this.calculateDropdownPosition()
      this.$nextTick(() => {
        setTimeout(() => {
          // this.welcomeDialogVisible = true
          this.startCountdown()
        }, 100)
      })
      this.isInitialLoad = false
    }
  },
  beforeDestroy() {
    if (this.countdownTimer) clearInterval(this.countdownTimer)
  },
  methods: {
    handleWarehouseChange(val) {
      const warehouse = this.warehouseOptions.find((i) => i.id === val)
      if (warehouse) {
        this.currentWarehouse = warehouse
        this.currentWarehouseId = warehouse.id
        this.$emit('warehouse-changed', warehouse.id)
        this.handleReset()
        this.showWelcomeMessage()
      }
    },
    handleSwitchWarehouseFromChild(warehouseId) {
      const target = this.warehouseOptions.find((i) => i.id === warehouseId)
      if (target) {
        this.currentWarehouse = target
        this.currentWarehouseId = target.id
        this.$message.success(`已自动切换到${target.label}列表`)
        this.handleReset()
      }
    },
    handleSearch() {
      this.$emit('search', this.filterForm)
    },
    handleReset() {
      this.filterForm = {
        state: '',
        putinTypeId: '',
        docNum: '',
        supplierName: '',
        drugName: '',
        startDate: '',
        endDate: '',
      }
      this.dateRange = []
      this.dateButtonText = '日期'
      this.expanded = false
    },
    handleDateConfirm(val) {
      if (val && val.length === 2) {
        this.filterForm.startDate = val[0]
        this.filterForm.endDate = val[1]
        this.dateButtonText = this.getDateDescription(val[0])
        this.handleSearch()
      } else {
        this.filterForm.startDate = ''
        this.filterForm.endDate = ''
        this.dateButtonText = '日期'
      }
      this.datePopoverVisible = false
    },
    getDateDescription(startDateStr) {
      // ...（保持不变，省略）
      if (!startDateStr) return '日期'
      const now = new Date()
      const start = new Date(startDateStr)
      const diffYears = now.getFullYear() - start.getFullYear()
      const diffMonths = now.getMonth() - start.getMonth()
      const diffDays = now.getDate() - start.getDate()
      const threeMonthsAgo = new Date()
      threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 3)
      const threeMonthsAgoStr = this.formatDate(threeMonthsAgo)
      const threeMonthsLater = new Date()
      threeMonthsLater.setMonth(threeMonthsLater.getMonth() + 3)
      const threeMonthsLaterStr = this.formatDate(threeMonthsLater)
      if (startDateStr === threeMonthsAgoStr) return '三个月前'
      if (startDateStr === threeMonthsLaterStr) return '三个月后'
      if (diffYears > 0) {
        const isFullYear = diffMonths > 0 || (diffMonths === 0 && diffDays >= 0)
        const years = isFullYear ? diffYears : diffYears - 1
        return years > 0 ? `${years}年前` : '1年前'
      }
      if (diffMonths > 0) return `${diffMonths}个月前`
      if (diffDays > 0) return `${diffDays}天前`
      if (diffDays === 0) return '今天'
      if (diffYears < 0) return `${Math.abs(diffYears)}年后`
      if (diffMonths < 0) return `${Math.abs(diffMonths)}个月后`
      if (diffDays < 0) return `${Math.abs(diffDays)}天后`
      return '日期'
    },
    formatDate(date) {
      const y = date.getFullYear()
      const m = String(date.getMonth() + 1).padStart(2, '0')
      const d = String(date.getDate()).padStart(2, '0')
      return `${y}-${m}-${d}`
    },
    handleImportExport(command) {
      const child = this.$refs.childComponent
      if (!child) {
        this.$message.warning('子组件尚未加载')
        return
      }
      if (command === 'batchImport') {
        child.handleBatchInbound()
      } else if (command === 'exportInfo') {
        child.handleExport()
      }
    },
    // 新建入库单
	handleCreateInbound() {
	  const child = this.$refs.childComponent;
	  if (!child) {
		this.$message.warning('子组件尚未加载');
		return;
	  }
	  // 设置模式为 'add'，然后调用子组件方法
	  this.dialogMode = 'add';
	  // 需要确保子组件能感知到 mode 变化，可以使用 nextTick
	  this.$nextTick(() => {
		child.handleCreateInbound();
	  });
	},
    handleUpdateTotalCost(cost) {
      this.totalCost = cost || 0
    },
    showWelcomeMessage() {
      this.countdown = 3
      this.startCountdown()
    },
    startCountdown() {
      if (this.countdownTimer) clearInterval(this.countdownTimer)
      this.countdownTimer = setInterval(() => {
        this.countdown--
        if (this.countdown <= 0) {
          this.handleCloseWelcome()
        }
      }, 1000)
    },
    handleCloseWelcome() {
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer)
        this.countdownTimer = null
      }
      const dialog = document.querySelector('.welcome-dialog')
      if (dialog) {
        const dialogRect = dialog.getBoundingClientRect()
        const containerRect = this.$el.getBoundingClientRect()
        const cx = dialogRect.left - containerRect.left + dialogRect.width / 2
        const cy = dialogRect.top - containerRect.top + dialogRect.height / 2
        const dx = this.dropdownPosition.x - cx
        const dy = this.dropdownPosition.y - cy
        const sx = this.dropdownPosition.width / dialogRect.width
        const sy = this.dropdownPosition.height / dialogRect.height
        const scale = Math.min(sx, sy) * 0.3
        dialog.style.transition = 'all 0.6s cubic-bezier(0.34, 1.56, 0.64, 1)'
        dialog.style.transform = `translate(${dx}px, ${dy}px) scale(${scale})`
        dialog.style.opacity = '0'
        setTimeout(() => {
          this.welcomeDialogVisible = false
          dialog.style.transition = ''
          dialog.style.transform = ''
          dialog.style.opacity = ''
        }, 600)
      } else {
        this.welcomeDialogVisible = false
      }
    },
    calculateDropdownPosition() {
      this.$nextTick(() => {
        const sel = document.querySelector('.warehouse-select')
        if (sel) {
          const rect = sel.getBoundingClientRect()
          const containerRect = this.$el.getBoundingClientRect()
          this.dropdownPosition = {
            x: rect.left - containerRect.left + rect.width / 2,
            y: rect.top - containerRect.top + rect.height / 2,
            width: rect.width,
            height: rect.height,
          }
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
// ===== 容器 =====
.shop-store-container {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 120px);
  background-color: #f5f7fa;
  overflow: hidden;
  box-sizing: border-box;
}

// ===== 顶部操作栏 =====
.top-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px 12px;
  background: #fff;
  padding: 8px 16px;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  margin-bottom: 8px;
  min-height: 40px;

  .top-bar-left {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;

    // ===== 切换库房盒子（样式与右侧“入库状态”盒子完全一致） =====
    .warehouse-switch-box {
      display: flex;
      align-items: center;
      border: 1px solid #dcdfe6;
      border-radius: 10px;
      padding: 2px 6px 2px 10px;
      background: #fff;
      height: 32px;
      gap: 0;
      .switch-label {
        font-size: 14px;
        color: #606266;
        line-height: 1;
        white-space: nowrap;
		font-weight: 500;
      }
      .warehouse-select {
        width: 80px;
        /deep/ .el-input__inner {
          border: none;
          background: transparent;
          padding-left: 18px;
		  line-height: 1;
          color: #409eff;
		  font-weight: 500;
          &:focus {
            box-shadow: none;
          }
        }
        /deep/ .el-input__suffix {
          right: 12px;
		  line-height: 1;
          .el-input__icon {
            color: #409eff;
          }
        }
      }
      
      .divider-line {
        width: 1px;
        height: 20px;
        background: #dcdfe6;
        margin: 0 6px;
        flex-shrink: 0;
      }
      
      .filter-search {
        width: 268px;
        /deep/ .el-input__inner {
          border: none;
          background: transparent;
          padding-right: 28px;
          font-size: 13px;
          &:focus {
            box-shadow: none;
          }
        }
        /deep/ .el-input__suffix {
          right: 4px;
          .el-input__icon {
            color: #909399;
            font-size: 14px;
          }
        }
      }
    }

    .divider {
      color: #dcdfe6;
      font-size: 14px;
      margin: 0 4px;
    }

    .btn-create {
      background-color: #409eff;
      border-color: #409eff;
      color: #fff;
      border-radius: 4px;
      &:hover {
        background-color: #66b1ff;
        border-color: #66b1ff;
      }
    }

    .btn-import-export {
      border: none;
      background: transparent;
      color: #606266;
      padding: 12px;
      cursor: pointer;
      &:hover {
        color: #409eff;
        background: rgba(64, 158, 255, 0.08);
      }
      .el-icon-arrow-down {
        font-size: 12px;
        margin-left: 2px;
      }
    }

    .import-export-dropdown {
      /deep/ .el-dropdown-menu {
        border: none !important;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.12);
        .el-dropdown-menu__item {
          &:hover {
            background-color: #f0f9ff;
            color: #409eff;
          }
        }
      }
    }
  }

  .top-bar-right {
    display: flex;
    align-items: center;
    gap: 8px;

    .filter-box {
      display: flex;
      align-items: center;
      border: 1px solid #dcdfe6;
      border-radius: 10px;
      padding: 2px 6px 2px 10px;
      background: #fff;
      height: 32px;
      gap: 0;

      .filter-state {
        width: 70px;
        /deep/ .el-input__inner {
          border: none;
          background: transparent;
          padding-left: 0;
          padding-right: 20px;
          font-size: 12px;
          color: #606266;
          &:focus {
            box-shadow: none;
          }
        }
        /deep/ .el-input__suffix {
          right: 0;
          .el-input__icon {
            color: #909399;
          }
        }
      }

      .divider-line {
        width: 1px;
        height: 20px;
        background: #dcdfe6;
        margin: 0 6px;
        flex-shrink: 0;
      }

      .filter-search {
        width: 268px;
        /deep/ .el-input__inner {
          border: none;
          background: transparent;
          padding-right: 28px;
          font-size: 13px;
          &:focus {
            box-shadow: none;
          }
        }
        /deep/ .el-input__suffix {
          right: 4px;
          .el-input__icon {
            color: #909399;
            font-size: 14px;
          }
        }
      }
    }

    .date-trigger {
      display: inline-flex;
      align-items: center;
      gap: 4px;
      color: #409eff;
      font-size: 13px;
      cursor: pointer;
      white-space: nowrap;
      padding: 0 8px;
      border: 1px solid #dcdfe6;
      border-radius: 10px;
      height: 32px;
      background: #fff;
      &:hover {
        color: #66b1ff;
        border-color: #66b1ff;
      }
      i {
        font-size: 14px;
      }
    }

    .popover-date-picker {
      /deep/ .el-input__inner {
        // 保持默认
      }
    }
  }
}

// ===== 表格标题 =====
.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  padding: 6px 16px;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);

  .table-title {
    font-size: 14px;
    font-weight: 500;
    color: #333;
  }

  .table-total {
    font-size: 13px;
    color: #606266;
    .total-amount {
      color: #f56c6c;
      font-weight: 600;
      font-size: 14px;
    }
  }
}

// ===== 表格容器 =====
.table-container {
  flex: 1;
  background: #fff;
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  border: 1px solid #e4e7ed;
  transition: all 0.3s ease;
}

// ===== 切换动画 =====
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all 0.3s ease;
}
.fade-slide-enter {
  opacity: 0;
  transform: translateX(20px);
}
.fade-slide-leave-to {
  opacity: 0;
  transform: translateX(-20px);
}
.fade-slide-enter-to,
.fade-slide-leave {
  opacity: 1;
  transform: translateX(0);
}

// ===== 欢迎模态框 =====
/deep/ .welcome-dialog {
  transition: all 0.6s cubic-bezier(0.34, 1.56, 0.64, 1) !important;
  transform-origin: center !important;
  .el-dialog__header {
    padding-bottom: 10px;
    border-bottom: 1px solid #e8e8e8;
  }
  .el-dialog__title {
    font-size: 16px;
    color: #409eff;
  }
  .welcome-content {
    display: flex;
    align-items: center;
    padding: 20px 0;
    .welcome-icon {
      margin-right: 20px;
      i {
        font-size: 48px;
        color: #67c23a;
      }
    }
    .welcome-text {
      flex: 1;
      h4 {
        margin: 0 0 10px 0;
        font-size: 18px;
        color: #333;
      }
      p {
        margin: 5px 0;
        color: #666;
        .countdown {
          color: #f56c6c;
          font-weight: bold;
        }
      }
    }
  }
  .dialog-footer {
    .el-button {
      min-width: 120px;
    }
  }
}

// ===== 响应式 =====
@media (max-width: 992px) {
  .top-bar {
    flex-direction: column;
    align-items: stretch;
    .top-bar-left,
    .top-bar-right {
      flex-wrap: wrap;
      justify-content: center;
    }
    .top-bar-right .filter-box {
      flex-wrap: wrap;
      height: auto;
      padding: 6px 10px;
      gap: 4px 0;
      .filter-state {
        width: 100px;
      }
      .filter-search {
        width: 268px;
      }
      .divider-line {
        display: none;
      }
    }
  }
}

@media (max-width: 768px) {
  .shop-store-container {
    padding: 4px;
    height: calc(100vh - 100px);
  }
  .top-bar {
    padding: 6px 10px;
    .top-bar-left {
      gap: 4px;
      .warehouse-switch-box {
        .warehouse-select {
          min-width: 50px;
        }
      }
      .btn-create {
        padding: 6px 10px;
        font-size: 12px;
      }
    }
    .top-bar-right .filter-box {
      .filter-state {
        width: 90px;
      }
      .filter-search {
        width: 268px;
      }
    }
  }
  .table-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
    padding: 6px 12px;
  }
}
</style>